import React from 'react';
import moment from 'moment';
import CancelAccount from '@/shadcn/components/CancelAccount.tsx';
import FullPageModal from 'app/components/common/FullPageModal.jsx';

/*
 * Thin adapter around the shadcn CancelAccount flow: it owns the modal chrome
 * and the one thing CancelAccount cannot do itself — format the billing date.
 * `moment` is a webpack external with no bundled types, so it stays on this side
 * of the TypeScript boundary and the date crosses as a plain string.
 *
 * The header is hidden and FullPageModal's close suppressed because
 * CancelAccount draws the designed dismiss itself, on every step.
 */
const CancellationModal = (props) => {
    return (
        <FullPageModal
            content={(
                <div className="tw-root">
                    <CancelAccount
                        app={props.app}
                        user={props.user}
                        newPlanLevel={props.newPlanLevel}
                        newPlanTerm={props.newPlanTerm}
                        nextBillingLabel={moment(props.user.plan.nextBilling).format('MMMM Do, YYYY')}
                        applyCoupon={props.applyCoupon}
                        closeAllModals={props.closeAllModals}
                        deleteApiError={props.deleteApiError}
                        getApiErrors={props.getApiErrors}
                        pauseSubscription={props.pauseSubscription}
                        planChangeHandler={props.planChangeHandler}/>
                </div>
            )}
            showClose={false}
            version="headerless hidden"
            closeAction={() => {
                props.closeAllModals();
            }}/>
    );
};

export default CancellationModal;
